import { DatePicker } from '@mui/x-date-pickers';
import React from 'react';

const Test = () => {
  return (
    <>
      <DatePicker />
    </>
  );
};

export default Test;
